import { Star } from "lucide-react";
import useStructuredData from "../hooks/useStructuredData";
import { TRUST_SCORE } from "../data/trustScore";

/** Renders nothing until TRUST_SCORE has a real, verified-reviews-only value — see trustScore.ts. */
export default function AggregateRatingBlock() {
  useStructuredData(
    TRUST_SCORE
      ? {
          "@context": "https://schema.org",
          "@type": "AggregateRating",
          ratingValue: TRUST_SCORE.averageRating,
          reviewCount: TRUST_SCORE.reviewCount,
          itemReviewed: { "@type": "Organization", name: "ZenFresh" },
        }
      : null
  );

  if (!TRUST_SCORE) return null;
  const trustScore = TRUST_SCORE;

  return (
    <div className="mx-auto flex w-fit items-center gap-3 rounded-full bg-white px-6 py-3 shadow-sm ring-1 ring-ocean-900/5">
      <div className="flex items-center gap-1 text-teal-500">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star
            key={i}
            className="h-4 w-4"
            fill={i < Math.round(trustScore.averageRating) ? "currentColor" : "none"}
          />
        ))}
      </div>
      <span className="text-sm font-semibold text-ocean-950">{trustScore.averageRating.toFixed(1)}</span>
      <span className="text-xs text-ocean-800/50">({trustScore.reviewCount.toLocaleString()} reviews)</span>
    </div>
  );
}
